<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="border-bottom: 1px solid #EEEEEE;padding-bottom: 10px;">
          <el-col :span="24" align="left">&nbsp;
            <el-input
              style="width: 200px"
              placeholder="请输入昵称"
              v-model="selectkey"
              clearable>
            </el-input>
            <el-button type="primary" @click="getstart()">开始查询</el-button>
            <el-checkbox v-model="checked" @change="getstart()">只显示会员</el-checkbox>
            <el-checkbox v-model="checked1" @change="getstart()">未开通会员</el-checkbox>

          </el-col>

        </el-row>
        <el-table
          :data="dataa"
          align="left"
          style="width: 100%">
          <el-table-column
            label="用户ID"
            prop="user_id">
          </el-table-column>
         <el-table-column
            label="推送ID"
            prop="clientid">
          </el-table-column>

          <el-table-column
            label="昵称"
            prop="nickname">
          </el-table-column>
<!--          <el-table-column-->
<!--            label="账号"-->
<!--            prop="account">-->
<!--          </el-table-column>-->
          <el-table-column
            label="性别">
            <template slot-scope="scope">
              {{ scope.row.gender=='1'?'男':scope.row.gender=='2'?'女':'' }}
            </template>
          </el-table-column>

          <el-table-column
            label="手机号"
            prop="phone"
            width="100">
          </el-table-column>
          <el-table-column
            label="余额"
            prop="balance">
          </el-table-column>
         <el-table-column
            label="是否是股东"
            prop="shareholder">
           <template slot-scope="scope">
             {{scope.row.shareholder==1?'是' :'否'}}
           </template>
          </el-table-column>
        <el-table-column
            label="成为股东时间"
            prop="gdtime"
        width="100px">
          <template slot-scope="scope">
            {{ formatDate(scope.row.gdtime) }}
          </template>
          </el-table-column>
          <el-table-column
            label="图片地址"
            width="120">
            <template slot-scope="scope">
              <img :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+scope.row.image_url"
                   alt="" width="80"  height="80">
            </template>
          </el-table-column>
          <el-table-column
            label="查看上级"
            width="100">
            <template slot-scope="scope">
              <el-button type="primary" @click="showSuperior(scope.row)" plain >查看</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="查看下级"
            width="100">
            <template slot-scope="scope">
              <el-button  @click="showSubordinate(scope.row.user_id)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="用户档案"
            width="100">
            <template slot-scope="scope">
              <el-button  @click="showSon(scope.row.user_id)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="注册时间"
            >
            <template slot-scope="scope">
              {{ formatDate(scope.row.regtime) }}
            </template>
          </el-table-column>
          <el-table-column
            label="会员过期时间"
            width="100px"
          >
            <template slot-scope="scope">
              {{ formatDateV(scope.row.vip_exp_time) }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="140">
            <template slot-scope="scope">
              <el-button @click="showEditSuperios(scope.row.user_id)" size="small" type="text">
                改变上级
              </el-button>
              <el-button @click="changevaluestate(scope.row.user_id,0)" size="small" type="text">删除</el-button>
<!--              <el-button  @click="openVip(scope.row,0)" size="small" type="text">开通会员</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 20px">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal">
            </el-pagination>
          </el-col>
        </el-row>
      </el-row>

      <el-dialog title="上级信息" :visible.sync="infoVisible" width="360px" :modal-append-to-body="false">
        <el-form label-position="left" class="demo-table-expand" label-width="108px" style="text-align: left">

          <el-form-item label="账号">
            <span>{{ infodata.account}}</span>
          </el-form-item>
          <el-form-item label="昵称">
            <span>{{ infodata.nickname}}</span>
          </el-form-item>
          <el-form-item label="性别">
            <span>{{gen(infodata.gender)}}</span>
          </el-form-item>
          <el-form-item label="头像">
            <img :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+infodata.image_url" style="width: 50px;height: 50px"/>
          </el-form-item>
          <el-form-item label="手机号">
            <span>{{ infodata.phone}}</span>
          </el-form-item>
          <el-form-item label="生日">
            <span>{{ infodata.birthday	}}</span>
          </el-form-item>
          <el-form-item label="余额">
            <span>{{ infodata.balance	}}</span>
          </el-form-item>
          <el-form-item label="注册时间">
            <span>{{ formatDate(infodata.regtime)	}}</span>
          </el-form-item>
          <!--<el-form-item label="课程详情:">-->
          <!--</el-form-item>-->
          <!--<div v-html="infodata.info"></div>-->
        </el-form>
      </el-dialog>

    </el-row>

    <el-dialog title="查看下级" :visible.sync="DetailsVisible" :modal-append-to-body="false">
      <el-row style="text-align: right">
<!--        <span>邀请开通大师vip的人数:{{detailsVipCount}}人</span>-->
      </el-row>
      <el-table :data="detailsOrderData"
                style="text-align: left">
        <el-table-column width="100" label="头像">
          <template slot-scope="scope">
            <img :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+scope.row.image_url" style="width: 50px;height: 50px"/>
          </template>
        </el-table-column>
        <el-table-column width="100" property="account" label="	账号"></el-table-column>
        <el-table-column width="100" property="nickname" label="昵称"></el-table-column>
        <el-table-column width="100" property="gender" label="性别"></el-table-column>
        <el-table-column width="100" property="phone" label="手机号"></el-table-column>
        <el-table-column width="100" property="birthday" label="生日"></el-table-column>
        <el-table-column width="100" property="balance" label="余额"></el-table-column>
        <el-table-column width="200" label="注册时间">
          <template slot-scope="scope">
            {{ formatDate(scope.row.regtime) }}
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 20px">
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <el-pagination
            style="text-align: right"
            background
            @size-change="ODhandleSizeChange"
            @current-change="ODhandleCurrentChange"
            :current-page="ODcurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="ODpagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ODdatatotal">
          </el-pagination>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog title="改变上级"  width="330px" :visible.sync="infoEditVisible" :modal-append-to-body="false">
      <el-row style="margin-bottom: 10px">
        <el-input placeholder="输入用户姓名" v-model="memberselectkey" class="input-with-select" @clear="editSuperior()" clearable>
          <el-button slot="append" icon="el-icon-search" @click="editSuperior()"></el-button>
        </el-input>
      </el-row>
      <el-table
        border
        align="left"
        :data="infoEditData"
        style="width: 100%">
        <el-table-column
          prop="user_id"
          label="用户ID"
          fixed="left"
          width="60">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号码"
          width="100">
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称">
        </el-table-column>
        <el-table-column
          label="">
          <template slot-scope="scope">

            <el-button @click="submitEdit(scope.row.user_id)" size="small" type="text">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row style="margin-top: 10px">
        <el-pagination
          small
          background
          @size-change="memberhandleSizeChange"
          @current-change="memberhandleCurrentChange"
          :current-page=" membercurrentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size=" memberpagesize"
          layout="prev, pager, next"
          :total="membertotal">
        </el-pagination>
      </el-row>
    </el-dialog>
    <!--档案-->
    <el-dialog title="档案列表" :visible.sync="sonVisible" :modal-append-to-body="false">
      <el-row style="padding-bottom: 10px;">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" style="text-align: right">
        </el-col>
      </el-row>
      <el-table :data="sonData"
                style="text-align: left">
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="relation"
          label="关系">
        </el-table-column>
        <el-table-column
          label="详情"
          width="100">
          <template slot-scope="scope">
            <el-button  @click="showSonDetail(scope.row.data_id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 20px">
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <el-pagination
            style="text-align: right"
            background
            @size-change="sonHandleSizeChange"
            @current-change="sonHandleCurrentChange"
            :current-page="sonCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="sonPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="sonDataTotal">
          </el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="档案详情" :visible.sync="sonDetailVisible" width="360px" :modal-append-to-body="false">
    <el-form label-position="left" class="demo-table-expand" label-width="108px" style="text-align: left">
          <el-form-item label="姓名">
              <span>{{sonDetailData.name}}</span>
          </el-form-item>
      <el-form-item label="关系">
        <span>{{sonDetailData.relation}}</span>
      </el-form-item>
      <el-form-item label="性别">
        <span>{{gen(sonDetailData.gender)}}</span>
      </el-form-item>
      <el-form-item label="头像">
        <img @click="showImg(sonDetailData.image_url)" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+sonDetailData.image_url" style="max-height: 50px">
      </el-form-item>
      <el-form-item label="出生日期">
        <span>{{sonDetailData.birthday}}</span>
      </el-form-item>
      <el-form-item label="手机号">
        <span>{{sonDetailData.phone}}</span>
      </el-form-item>
      <el-form-item label="出生地">
        <span>{{sonDetailData.birth_place}}</span>
      </el-form-item>
      <el-form-item label="现居地">
        <span>{{sonDetailData.current_place}}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
    <el-button @click="sonDetailVisible = false">关闭</el-button>
    </div>
    </el-dialog>

    <!--档案-->
    <el-dialog title="档案列表" :visible.sync="sonVisible" :modal-append-to-body="false">
      <el-row style="padding-bottom: 10px;">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" style="text-align: right">
        </el-col>
      </el-row>
      <el-table :data="sonData"
                style="text-align: left">
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="relation"
          label="关系">
        </el-table-column>
        <el-table-column
          label="详情"
          width="100">
          <template slot-scope="scope">
            <el-button  @click="showSonDetail(scope.row.data_id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 20px">
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <el-pagination
            style="text-align: right"
            background
            @size-change="sonHandleSizeChange"
            @current-change="sonHandleCurrentChange"
            :current-page="sonCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="sonPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="sonDataTotal">
          </el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="图片查看" :visible.sync="showImgVisible" width="800px" :modal-append-to-body="false">
      <div style="width: 100%;height: 100%">
        <img :src="showImgValue" style="max-width: 750px">
      </div>
    </el-dialog>


    <el-dialog title="会员开通" :visible.sync="vipVisible" width="360px" :modal-append-to-body="false">
        <el-form >
            <el-form-item label="会员类型" label-width="80px">
              <el-select v-model="vipValue" placeholder="请选择会员类型">
                <el-option label="普通会员一个月" value="vip1"></el-option>
                <el-option label="普通会员三个月" value="vip3"></el-option>
                <el-option label="普通会员六个月" value="vip6"></el-option>
                <el-option label="大师会员" value="vip12"></el-option>
              </el-select>
            </el-form-item>
       </el-form>
      <div slot="footer" class="dialog-footer">
      <el-button @click="vipVisible = false">取 消</el-button>
      <el-button type="primary" @click="postVip()">确 定</el-button>
      </div>
    </el-dialog>

    <!--<el-dialog title="改变上级" :visible.sync="infoEditVisible" width="360px" :modal-append-to-body="false">-->
      <!--<el-form label-position="left" class="demo-table-expand" label-width="108px" style="text-align: left">-->
        <!--<el-form-item label="上级">-->
          <!--<el-select v-model="infoEditValue" placeholder="请选择上级">-->
            <!--<el-option v-for="(item,index) in infoEditData" :label="item.nickname" :value="item.user_id"-->
                       <!--:key="index"></el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
      <!--<div slot="footer" class="dialog-footer">-->
        <!--<el-button @click="infoEditVisible = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="submitEdit()">确 定</el-button>-->
      <!--</div>-->
    <!--</el-dialog>-->
    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>
  export default {
    name: "User",
    mounted() {
      if (!this.$store.state.login.in) {
        this.$router.push({name: "login", params: {userId: 123}})
      }
      this.getstart()
    },
    data() {
      return {
        checked: false,
        checked1: false,
        infoEditValue:'',
        infoEditData:[]
,        infoEditVisible:false,
        infoVisible: false,
        infodata: {},
        selectkey:'',
        dataa: [],
        datatotal: 0,
        pagesize: 10,
        currentPage: 1,
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        activeName: '',
        fullscreenLoading: false,
        //表格
        formLabelWidth: '100px',
        deleteMoreOrderdata:[],
        ODcurrentPage:1,
        ODpagesize:10,
        ODdatatotal:0,
        detailsOrderData:[],
        DetailsVisible:false,
        userId:'',
        memberselectkey: '',
        memberpagesize:10,
        membercurrentPage:1,
        membertotal:0,
        sonVisible:false,
        sonCurrentPage:1,
        sonPageSize:10,
        sonDataTotal:0,
        sonData:[],
        sonID:'',
        sonDetailData:[],
        sonDetailVisible:false,
        showImgVisible:false,
        showImgValue:'',
        vipVisible:false,
        vipId:'',
        vipValue:'',
        detailsVipCount:0
      }
    },
    computed: {

    },
    watch: {},
    methods: {
      gen(gen){
        if(gen==1){
          return '男'
        }
       if(gen==2){
          return '女'
        }
      },
      //开通会员
      openVip(item){
        let vt= item.vip_exp_time
        let is=true
        if(vt){
          let nt= Math.floor((new Date()).getTime()/1000)
          if(parseInt(vt)-nt>0){
            this.$message({
              type: 'warning',
              message: '会员还未到期！'
            });
            is=false
          }
        }
        if(is){
          this.vipVisible=true
          this.vipId=item.user_id
        }
      },
      //提交开通会员
      postVip(){
        if(!this.vipValue){
          this.$message({
            type: 'warning',
            message: '请选择会员类型！'
          });
          return
        }
        let por={
          user_id:this.vipId,
          vip_level:this.vipValue,
        }
       this.mySubmit('makeVip',por).then(code=>{
         if(code==200){
           this.vipVisible=false
           this.getstart()
         }
       })
      },
      // 图片查看
      showImg(url){
        this.showImgVisible=true
        this.showImgValue='http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+url
      },
      //显示用户档案
      showSon(uid){
        this.sonID=uid
        this.sonVisible=true
        this.getSonTable()
      },
      //获取用户档案
      getSonTable(){
        this.mySelectAll('dataList',{user_id:this.sonID}).then(value => {
          this.sonData=value.data;
          this.sonDataTotal=value.Total;
        })
      },
      //显示用户档案详情
      showSonDetail(id){
        this.mySelect('dataInfo',{data_id:id}).then(data=>{
          this.sonDetailData=data
          this.sonDetailVisible=true
        })
      },
      panduanleixing2(type) {
        switch (type) {
          case '1':
            return "";
            break;
          case '2':
            return "success";
            break;
          case '3':
            return "success";
            break;
          case '4':
            return "info";
            break;
          default:
            return null;
        }
      },

      //选择展示数量
      handleSizeChange(val) {
        this.pagesize = val
        this.getstart()
      },
      //跳转页面
      handleCurrentChange(val) {
        this.currentPage = val
        this.getstart()
      },
      getstart() {
        let thi = this
        console.log(thi.checked,'thi.checked')
        if(thi.checked==true){
          thi.onlyMember='1'
          thi.checked1=false
        }
        if(thi.checked1==true){
          thi.onlyMember='2'
           thi.checked=false
        }
    if(thi.checked==false && thi.checked1==false){
          thi.onlyMember='0'
        }
        thi.fullscreenLoading = true
        console.log(thi.ODcurrentPage,'thi.ODcurrentPage')
        thi.$http.post(global.posturl.host + global.posturl.userList, {
          page: thi.currentPage,
          pageSize: thi.pagesize,
          key:thi.selectkey,
          onlyMember:thi.onlyMember
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.dataa = qdata
            thi.datatotal = qtotal
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      handleNodeClick(data) {
        console.log(data);
      },

      //删除提示
      changevaluestate(user_id, state) {
        var heeh = '该'
        var caozuo = '禁用'
        if (user_id.length > 1) {
          heeh = '这些'
        }
        if (state == 0) {
          caozuo = '删除'
        }
        let thi = this
        thi.$confirm('此操作将' + caozuo + heeh + '账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.submitchangestate(user_id, state)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消' + caozuo
          });
        });
      },
      //状态改变(删除)
      submitchangestate(user_id,state ) {
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userStateChange, {
          user_id: user_id,
          state: 0,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      showEditSuperios(userid){
        this.infoEditVisible=true
        this.userId=userid
        this.editSuperior()
      },
      //改变上级
      editSuperior(userid) {
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userList, {
          page : thi.membercurrentPage,
          pageSize : thi.memberpagesize,
          key: thi.memberselectkey,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qdata = response.data.data
          if (qcode == 200) {
            thi.infoEditData=qdata
            thi.membertotal = response.data.Total
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      //提交改变上级
      submitEdit(uid){
        let thi = this
        thi.fullscreenLoading = true
        const por={
          user_id: thi.userId,
          referrer_id: uid,
        }
        console.log(por)
        this.$http.post(global.posturl.host + global.posturl.changeSuperior, por
        ).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qdata = response.data.data
          var qmsg = response.data.msg
          if (qcode == 200) {
            thi.$message({
              type: 'success',
              message: qmsg
            });
            thi.infoEditVisible=false
            thi.getstart()
          }else {
            thi.$message({
              type: 'warning',
              message: qmsg
            });
          }
          thi.fullscreenLoading = false

        }).catch(function (error) {
          console.log(error)
        });
      },
      // 查看上级
      showSuperior(row){
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.superior, {
          user_id: row.user_id,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qdata = response.data.data
          var qmsg = response.data.msg
          if (qcode == 200) {
            thi.infoVisible = true
            thi.infodata =qdata
          }else {
            thi.$message({
              type: 'warning',
              message: qmsg
            });
          }
          thi.fullscreenLoading = false

        }).catch(function (error) {
          console.log(error)
        });
        // thi.infodata = JSON.parse(JSON.stringify(row));
      },
      //选择展示数量
      memberhandleSizeChange(val) {
        this.memberpagesize=val
        this.editSuperior()
      },
      //跳转页面
      memberhandleCurrentChange(val) {
        this.membercurrentPage=val
        this.editSuperior()
      },
      //查看下级
      showOrderDetails(data){
        this.getOrderDetails(data.id)
      },
      //查看下级
      showSubordinate(aid,uuw){
        console.log(aid)
        this.uus=aid
        let thi = this
        console.log(thi.ODcurrentPage,'thi.ODcurrentPage')
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.subordinate, {
          page : uuw ||'1',
          pageSize : thi.ODpagesize,
          // key: thi.PLselectkey,
          user_id : aid,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if(qcode==200){
            thi.DetailsVisible=true
            thi.detailsOrderData=qdata.list;
            thi.detailsVipCount=qdata.invite_vip_count||0;
            thi.ODdatatotal=qtotal;
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      //子页选择展示数量
      sonHandleSizeChange(val) {
        this.sonPageSize=val
        this.getSonTable()
      },
      //子页跳转页面
      sonHandleCurrentChange(val) {
        this.sonCurrentPage=val
        this.getSonTable()
      },

      //评论页选择展示数量
      ODhandleSizeChange(val) {
        this.ODpagesize=val
        this.showSubordinate(this.uus)
        console.log(this.uus,'this.uus')
      },
      //评论分页跳转页面
      ODhandleCurrentChange(val) {
        this.ODcurrentPage=val
        this.showSubordinate(this.uus,this.ODcurrentPage)
      },
      //格式化时间
      formatDate(date) {
        if (!date) {
          return "无"
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "年" + (this.getMonth() + 1) + "月" + this.getDate() + "日" + this.getHours() + "点" + this.getMinutes() + "分" + this.getSeconds() + "秒";
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
      //格式化时间
      formatDateV(date) {
        if (!date) {
          return "未开通"
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "年" + (this.getMonth() + 1) + "月" + this.getDate() + "日" + this.getHours() + "点" + this.getMinutes() + "分" + this.getSeconds() + "秒";
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
      //状态改变（启用）
      changeUserState(user_id, state) {
        //方法传进来的，不用this.
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userStateChange, {
          user_id: user_id,
          state: state
        }).then(function (response) {
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //白名单状态改变
      changeUserState(user_id, state) {
        //方法传进来的，不用this.
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userwhitelistChange, {
          user_id: user_id,
          whitelist: state
        }).then(function (response) {
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/user/User.vue